import React, { Component } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import css from './BAGBenifitsSection.css';
import benifit_bg from '../../assets//becomeAGuest/benifit-bg-min.jpg';

const onManageDisableScrolling = (componentId, scrollingDisabled = true) => {
  // We are just checking the value for now

};

const ModalVideo = props => {
  return (
    <div className={css.videoContentWrapper}>
      <iframe
        className={css.iframeVideo}
        allowFullScreen={true}
        src="https://www.youtube.com/embed/OaOzjZiVaws">
      </iframe>
    </div>
  );
};

class BAGBenifitsSection extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };
    this.handleOpen = this.handleOpen.bind(this);
  }

  handleOpen() {
    this.setState({ isOpen: true });
  }

  render() {
    return (
      <section className={css.benifitSection}>
        <div className={css.box1} />
        <div className={css.box2}>
          <div className={css.row}>
            <img src={benifit_bg} className={css.benifit_bg} />
            <h4 className={css.textBoxTitle1}>
              <FormattedMessage id="BecomeAGuestPage.benifitTitle2" values={{ newline: <br /> }} />
            </h4>
          </div>
          <div className={css.listTextBox}>
            <div className={css.subBox}>
              <div className={css.subBoxTitle}>
                <FormattedMessage id="BecomeAGuestPage.subBoxTitle1" values={{ newline: <br /> }} />
              </div>
              <div className={css.subBoxDesc}>
                <FormattedMessage id="BecomeAGuestPage.subBoxDesc1" values={{ newline: <br /> }} />
              </div>
            </div>
            <div className={css.subBox}>
              <div className={css.subBoxTitle}>
                <FormattedMessage id="BecomeAGuestPage.subBoxTitle2" values={{ newline: <br /> }} />
              </div>
              <div className={css.subBoxDesc}>
                <FormattedMessage id="BecomeAGuestPage.subBoxDesc2" values={{ newline: <br /> }} />
              </div>
            </div>
            <div className={css.subBox}>
              <div className={css.subBoxTitle}>
                <FormattedMessage id="BecomeAGuestPage.subBoxTitle3" values={{ newline: <br /> }} />
              </div>
              <div className={css.subBoxDesc}>
                <FormattedMessage id="BecomeAGuestPage.subBoxDesc3" values={{ newline: <br /> }} />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default BAGBenifitsSection;
